import { render } from "./MenuHeaderSingleBtn.vue?vue&type=template&id=4ceeeb31"
import script from "./MenuHeaderSingleBtn.vue?vue&type=script&lang=js"
export * from "./MenuHeaderSingleBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__